export default __webpack_public_path__ + "static/media/persona1.bea754dc.jpg";